import React, { useState } from "react";
import MessageViewModal from "../Modal/MessageViewModal";
import { ChevronsUpDown, Eye } from "lucide-react";
import Skeleton from "react-loading-skeleton";
const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function BulkLetterDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    selectAll = false,
    checkedIds = [],
    checkSelected = false,
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {}
  } = props;

  const LimitText = ({ text, limit }) => {
    if (text.length <= limit) {
      return text;
    } else {
      const limitText = text.substring(0, limit) + "...";
      return limitText;
    }
  };

  const [orderBy, setOrderBy] = useState();
  const [activeModal, setActiveModal] = useState(false);
  const [detailsData, setDetailsData] = useState(null);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] === name) {
      if (reloadDataFilter.order_by[1] === "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };

  const handleNoteView = (details) => {
    setDetailsData(details);
    setActiveModal(!activeModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }
  
  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              {/* <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && selectAll}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th> */}
              {/* <th>ID</th> */}
              <th
                onClick={() => {
                  handleOrderChange("letter_type");
                }}
                className={
                  orderBy === "letter_type" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Letter Type <ChevronsUpDown size={"12"} />
                </div>
              </th>

              {/* <th
                onClick={() => {
                  handleOrderChange("receiver_address");
                }}
                className={
                  orderBy === "receiver_address" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Phone <ChevronsUpDown size={"12"} />
                </div>
              </th> */}
              <th>Letter Body</th>

              <th
                onClick={() => {
                  handleOrderChange("status");
                }}
                className={orderBy === "status" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Status <ChevronsUpDown size={"12"} />
                </div>
              </th>
              {/* <th>Segment</th> */}
              <th
                onClick={() => {
                  handleOrderChange("created_at");
                }}
                className={orderBy === "created_at" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Create Time <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    {/* <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={item.checked || false}
                          onChange={() => handleCheckboxChange(item.id)}
                        />
                        <label></label>
                      </div>
                    </td> */}
                    {/* <td>{item.id}</td> */}
                    <td>{item.notificationType}</td>
                    <td>
                      <LimitText text={item.messageBody} limit={30} />
                    </td>
                    <td>{item.status}</td>
                    {/* <td>{item.segment}</td> */}
                    <td>{item.createdAt}</td>
                    <td>
                      <div className="docpro_icon_btns">
                        <button
                          className="docpro_icon_btn"
                          onClick={() => handleNoteView(item)}
                        >
                          <Eye width={20} height={20} />
                          <span className="docpro_tip">View Message</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="5">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td> <Skeleton width={`${3 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${2 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5.5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-center"> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeModal && (
        <MessageViewModal
          activeModal={activeModal}
          setActiveModal={setActiveModal}
          message_body={detailsData?.messageBody}
          segment={detailsData?.segment}
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}
